import { Modal, ModalProps, SxProps, Theme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

const style: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
};

export type CustomModalProps = ModalProps & {
  contentSx?: SxProps<Theme>;
};

export const CustomModal = ({ contentSx, children, ...props }: CustomModalProps) => {
  const combinedSx: SxProps<Theme> = contentSx
    ? Array.isArray(contentSx)
      ? [style, ...contentSx]
      : [style, contentSx]
    : style;

  return (
    <Modal
      {...props}
      slotProps={{
        backdrop: {
          style: {
            // backdropFilter: "blur(2px)",
            opacity: 0.4,
          },
        },
      }}
    >
      <Box sx={combinedSx}>{children}</Box>
    </Modal>
  );
};
